<template>
    <div>
        <template v-if="is_scoring_loading">
            <div class="d-flex align-items-center justify-content-center p-4">
                <h5>
                    <span class="mr-3">로딩중</span>
                    <b-spinner class=""/>
                </h5>
            </div>
        </template>
        <template v-else>
            <!-- Structure 미리보기 -->
            <template v-if="!read_only">
                <b-card id="structure-preview" class="mb-4"
                        :header="`${sub_code} / Preview`"
                >
                    <template v-if="sub">
                        <b-tabs>
                            <b-tab title="문항 미리보기" class="p-3 border-right border-left border-bottom">
                                <sub-component
                                    :sub_type="sub.sub_type"
                                    :item="sub"
                                    :preview="true"
                                    :view_pipe_line="false"
                                    :is_disabled_by_parent="true"
                                    :skip_info="true"
                                />
                            </b-tab>
                            <b-tab title="문항 데이터 보기" class="p-3 border-right border-left border-bottom">
                                <div class="mb-3">
                                    <p class="font-weight-bold mb-1">해당없음, 증빙첨부 여부, 필수답변, 첨부필수(sub_data_header)</p>
                                    <div class="border rounded vh-100" style="max-height: 150px;overflow-y: auto;">
                                        <pre class="p-3">{{ sub.sub_data_header }}</pre>
                                    </div>
                                </div>
                                <div>
                                    <p class="font-weight-bold mb-1">문항 보기 및 표 구조(sub_data_contents)</p>
                                    <div class="border rounded vh-100" style="max-height: 250px;overflow-y: auto;">
                                        <pre class="p-3">{{ sub.sub_data_contents }}</pre>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </template>
                </b-card>
            </template>

            <b-card no-body class="mb-4">
                <template #header>
                    <div class="d-flex align-items-center justify-content-between">
                        <h6 class="mb-0"> Scoring </h6>

                        <b-button variant="primary" size="sm"
                                  @click="addMethod"
                        >
                            추가
                        </b-button>
                    </div>
                </template>
                <template v-if="!read_only">
                    <b-table-simple :hover="!isDragging"  class="mb-0">
                        <!-- class="rep-table" -->
                        <b-thead>
                            <b-tr>
                                <b-td> No.</b-td>
                                <b-td> Scoring Method</b-td>
                                <b-td style="width: 40%;">
                                    <div class="d-flex justify-content-between align-items-center" style="gap: 12px">
                                        <div style="width: 43%" class="text-center">
                                            충족 코드
                                        </div>
                                        <div style="width: 43%" class="text-center">
                                            미충족 코드
                                        </div>
                                        <div style="width: 14%" class="text-center">
                                            첨부 무시
                                        </div>
                                    </div>

                                </b-td>
                            </b-tr>
                        </b-thead>
                            <template v-if="!scoring_structure.length">
                                <b-tbody>

                                <b-tr>
                                    <b-td class="text-center p-4" colspan="3">
                                        이 문항은 점수 조건이 정의되지 않았습니다.
                                    </b-td>
                                </b-tr>
                                </b-tbody>
                            </template>
                            <template v-else>
                                <draggable
                                    v-model="scoring_structure"
                                    tag="tbody"
                                    handle=".drag-handle"
                                    animation="200"
                                    ghost-class="ghost-placeholder"
                                    drag-class="dragging-item"
                                    class="draggable-list"
                                    :class="{'is-dragging': isDragging}"
                                    @start="isDragging = true"
                                    @end="onDragEnd"
                                >
                                    <tr v-for="(item, index) in scoring_structure" :key="item.id || index" :class="{'is-dragging': isDragging}">
                                        <td class="align-middle d-flex align-items-center">
                                            <div class="drag-handle mr-2" title="순서 변경">
                                                <fa icon="grip-vertical" class="handle" />
                                            </div>
                                            <span>{{ index+1 }}</span>
                                        </td>
                                        <td class="text-left py-2">
                                            <div class="mb-2">
                                                <p class="f-90 mb-0"> <strong>*</strong> 평가결과 산출식 </p>
                                                <b-textarea v-model="item.formula"
                                                            :class="[{ 'blue4': temp_new === true }]"
                                                            row="3"
                                                            trim
                                                            @input="editedScoreMethod(index, 'formula')"
                                                >
                                                    {{ item.formula }}
                                                </b-textarea>
                                            </div>

                                            <b-collapse :id="`collapse-scoring-${index}`">
                                                <div class="mb-3">
                                                    <p class="f-90 mb-0"><strong>*</strong> 충족</p>
                                                    <b-form-input v-model="item.name"
                                                                  :class="[{ 'blue4': temp_new === true }, 'mb-2']"
                                                                  trim
                                                                  @input="editedScoreMethod(index, 'name')"
                                                    >
                                                        {{ item.name }}
                                                    </b-form-input>

                                                    <b-input-group class="mb-2">
                                                        <b-form-input v-model="item.name_ea"
                                                                      :placeholder="!item.name_ea ? '우측 번역 버튼을 클릭해 자동 생성 또는 직적 입력해주세요.' : '충족 영문 번역'"
                                                                      trim
                                                                      @input="editedScoreMethod(index, 'name_ea')"
                                                        >
                                                            {{ item.name }}
                                                        </b-form-input>

                                                        <b-input-group-append>
                                                            <b-btn variant="secondary"
                                                                   :disabled="isFieldEmpty(item.name) || is_scoring_translated"
                                                                   @click="translateScoringTextField(index, 'name', 'name_ea', 'ea')"
                                                            >
                                                                번역
                                                                <b-spinner v-show="item.is_translating_name_ea"
                                                                           style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                            </b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>

                                                    <b-input-group class="mb-2">
                                                        <b-form-input v-model="item.name_c"
                                                                      :placeholder="!item.name_c ? '우측 번역 버튼을 클릭해 자동 생성 또는 직적 입력해주세요.' : '충족 중문 번역'"
                                                                      trim
                                                                      @input="editedScoreMethod(index, 'name_c')"
                                                        >
                                                            {{ item.name }}
                                                        </b-form-input>

                                                        <b-input-group-append>
                                                            <b-btn variant="secondary"
                                                                   :disabled="isFieldEmpty(item.name) || is_scoring_translated"
                                                                   @click="translateScoringTextField(index, 'name', 'name_c', 'ca')"
                                                            >
                                                                번역
                                                                <b-spinner v-show="item.is_translating_name_ca"
                                                                           style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                            </b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>

                                                <div class="mb-3">
                                                    <p class="f-90 mb-0"><strong>*</strong> 미충족 (Reverse)</p>
                                                    <b-form-input v-model="item.reverse_name"
                                                                  class="mb-2"
                                                                  trim
                                                                  @input="editedScoreMethod(index, 'reverse_name')"
                                                    >
                                                        {{ item.name }}
                                                    </b-form-input>
                                                    <b-input-group class="mb-2">
                                                        <b-form-input v-model="item.reverse_name_ea"
                                                                      :placeholder="!item.reverse_name_ea ? '우측 번역 버튼을 클릭해 자동 생성 또는 직적 입력해주세요.' : '미충족 영문 번역'"
                                                                      trim
                                                                      @input="editedScoreMethod(index, 'reverse_name_ea')"
                                                        >
                                                            {{ item.reverse_name_ea }}
                                                        </b-form-input>
                                                        <b-input-group-append>
                                                            <b-btn variant="secondary"
                                                                   :disabled="isFieldEmpty(item.reverse_name) || is_scoring_translated"
                                                                   @click="translateScoringTextField(index, 'reverse_name', 'reverse_name_ea', 'ea')"
                                                            >
                                                                번역
                                                                <b-spinner v-show="item.is_translating_reverse_name_ea"
                                                                           style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                            </b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>

                                                    <b-input-group class="mb-2">
                                                        <b-form-input v-model="item.reverse_name_ca"
                                                                      :placeholder="!item.reverse_name_ca ? '우측 번역 버튼을 클릭해 자동 생성 또는 직적 입력해주세요.' : '미충족 중문 번역'"
                                                                      trim
                                                                      @input="editedScoreMethod(index, 'reverse_name_ca')"
                                                        >
                                                            {{ item.reverse_name_ca }}
                                                        </b-form-input>
                                                        <b-input-group-append>
                                                            <b-btn variant="secondary"
                                                                   :disabled="isFieldEmpty(item.reverse_name) || is_scoring_translated"
                                                                   @click="translateScoringTextField(index, 'reverse_name', 'reverse_name_ca', 'ca')"
                                                            >
                                                                번역
                                                                <b-spinner v-show="item.is_translating_reverse_name_ca"
                                                                           style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                            </b-btn>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </div>

                                                <div class="mb-2">
                                                    <div class="d-flex">
                                                        <div class="flex-grow-1">
                                                            <p class="f-90 mb-0 mt-1">컴플라이언스</p>
                                                            <b-form-checkbox
                                                                v-model="item.is_compliance"
                                                                :name="`input-check-complicance-${index}`"
                                                                :class="[{ 'blue4': temp_new === true }]"
                                                                @change="editedScoreMethod(index, 'is_compliance')"
                                                            >
                                                                적용
                                                            </b-form-checkbox>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="f-90 mb-0 mt-1">액션 플랜</p>
                                                            <b-form-checkbox v-model="item.is_ap"
                                                                             :name="`input-check-action-plan-${index}`"
                                                                             :class="[{ 'blue4': temp_new === true }]"
                                                                             @change="editedScoreMethod(index, 'is_ap')"
                                                            >
                                                                적용
                                                            </b-form-checkbox>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="f-90 mb-0 mt-1">리스크</p>
                                                            <b-dropdown
                                                                :text="!item.risk_level ? '(미지정)' : risk_level_lang_ea[item.risk_level]"
                                                                class=""
                                                                size="sm"
                                                                :disabled="read_only === true"
                                                                toggle-class="px-3"
                                                            >
                                                                <b-dropdown-item @click="changeRiskLevel(index, '높음')">
                                                                    높음
                                                                </b-dropdown-item>
                                                                <b-dropdown-item @click="changeRiskLevel(index, '중간')">
                                                                    중간
                                                                </b-dropdown-item>
                                                                <b-dropdown-item @click="changeRiskLevel(index, '낮음')">
                                                                    낮음
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </div>
                                                </div>

                                                <b-collapse v-model="item.is_ap" class="mb-2">
                                                    <p class="f-90 mb-1 mt-1">액션플랜 적용시 설명</p>
                                                    <div>
                                                        <b-form-textarea :id="`action-plan_description-${index}`"
                                                                         v-model="item.ap_description"
                                                                         :name="`action-plan_description-${index}`"
                                                                         :placeholder="!item.is_ap ? '액션 플랜이 적용되면 활성화됩니다.' : '(한글) 액션 플랜 설명'"
                                                                         class="mb-2"
                                                                         :disabled="!item.is_ap"
                                                                         trim
                                                                         rows="3"
                                                                         max-rows="7"
                                                                         @input="editedScoreMethod(index, 'ap_description')"
                                                        >
                                                        </b-form-textarea>
                                                        <b-input-group class="mb-2">
                                                            <b-form-textarea :id="`action-plan_description_e-${index}`"
                                                                             v-model="item.ap_description_ea"
                                                                             :name="`action-plan_description-${index}`"
                                                                             :placeholder="!item.is_ap ? '액션 플랜이 적용되면 활성화됩니다.' : isFieldEmpty(item.ap_description) ? '국문 작성 후 자동번역된 설명을 수정하실 수 있습니다.' : '(영문) 액션 플랜 설명'"
                                                                             :disabled="!item.is_ap"
                                                                             trim
                                                                             rows="3"
                                                                             max-rows="7"
                                                                             @input="editedScoreMethod(index, 'ap_description_ea')"
                                                            >
                                                            </b-form-textarea>

                                                            <b-input-group-append>
                                                                <b-btn variant="secondary"
                                                                       :disabled="isFieldEmpty(item.ap_description) || is_scoring_translated"
                                                                       @click="translateScoringTextField(index, 'ap_description', 'ap_description_ea', 'ea')"
                                                                >
                                                                    번역
                                                                    <b-spinner
                                                                        v-show="item.is_translating_ap_description_ea"
                                                                        style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                                </b-btn>
                                                            </b-input-group-append>
                                                        </b-input-group>

                                                        <b-input-group>
                                                            <b-form-textarea :id="`action-plan_description_c-${index}`"
                                                                             v-model="item.ap_description_ca"
                                                                             :name="`action-plan_description-${index}`"
                                                                             :placeholder="!item.is_ap ? '액션 플랜이 적용되면 활성화됩니다.' : isFieldEmpty(item.ap_description) ? '국문 작성 후 자동번역된 설명을 수정하실 수 있습니다.' : '(중문) 액션 플랜 설명'"
                                                                             :disabled="!item.is_ap"
                                                                             trim
                                                                             rows="3"
                                                                             max-rows="7"
                                                                             @input="editedScoreMethod(index, 'ap_description_ca')"
                                                            >
                                                            </b-form-textarea>

                                                            <b-input-group-append>
                                                                <b-btn variant="secondary"
                                                                       :disabled="isFieldEmpty(item.ap_description) || is_scoring_translated"
                                                                       @click="translateScoringTextField(index, 'ap_description', 'ap_description_ca', 'ca')"
                                                                >
                                                                    번역
                                                                    <b-spinner
                                                                        v-show="item.is_translating_ap_description_ca"
                                                                        style="width: 1.2rem; height: 1.2rem;"></b-spinner>
                                                                </b-btn>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                </b-collapse>

                                                <div class="mb-0">
                                                    <p class="f-90 mb-1 mt-1">kesg id</p>
                                                    <b-form-input
                                                        id="input-1"
                                                        v-model="item.kesg_id"
                                                        placeholder="관련 kesg id를 기재해주세요"
                                                        trim
                                                        @input="editedScoreMethod(index, 'kesg_id')"
                                                    >
                                                    </b-form-input>
                                                </div>
                                            </b-collapse>
                                        </td>
                                        <td>
                                            <div class="d-flex justify-content-between align-items-center mb-2"
                                                 style="gap: 12px">

                                                <b-form-select v-model="item.pos_ev_code"
                                                               :options="get_pos_ev_code_options"
                                                               @change="editedScoreMethod(index, 'pos_ev_code')"
                                                >
                                                </b-form-select>
                                                <b-form-select v-model="item.neg_ev_code"
                                                               :options="get_neg_ev_code_options"
                                                               @change="editedScoreMethod(index, 'neg_ev_code')"
                                                >
                                                </b-form-select>
                                                <b-form-checkbox
                                                    v-model="item.ignore_attach"
                                                    name="ignore_attach"
                                                    :value="1"
                                                    :unchecked-value="0"
                                                    @change="editedScoreMethod(index, 'ignore_attach')"
                                                >
                                                </b-form-checkbox>
                                            </div>


                                            <b-btn-group class="d-flex">
                                                <b-btn v-b-toggle="`collapse-scoring-${index}`"
                                                       size="sm"
                                                >
                                                    <BIconChevronBarExpand/>
                                                </b-btn>

                                                <b-btn
                                                    variant="danger" size="sm"
                                                    @click="deleteMethod(index)"
                                                >
                                                    <BIconTrashFill font-scale="0.95" shift-v="2"/>
                                                </b-btn>
                                            </b-btn-group>
                                        </td>
                                    </tr>
                                </draggable>
                            </template>
                    </b-table-simple>
                </template>
                <template v-else-if="!temp_new">
                    <b-table-simple hover class="f-90 bor-table mb-0">
                        <b-thead>
                            <b-tr class="bgray-200">
                                <b-td style="max-width:14px;" class="p-0 "> N.</b-td>
                                <b-td colspan="2"> 점수조건</b-td>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-for="(item, index) in scoring_structure" :key="index">
                            <b-tr>
                                <b-td class="border-right border-color-gray-300 bgray-200"
                                      rowspan="4"
                                      style="max-width:14px;"
                                >
                                    {{ index + 1 }}
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td> 조건:</b-td>
                                <b-td>{{ item.formula }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td> 충족:</b-td>
                                <b-td>{{ item.name }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td> 미충족:</b-td>
                                <b-td>{{ item.reverse_name }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </template>
                <template v-else>
                    <div class="py-5 text-center gray-500">
                        이 문항은 점수 조건이 정의되지 않았습니다.
                    </div>
                </template>
            </b-card>

            <!-- Structure 미리보기 -->
            <template v-if="!read_only">
                <template v-if="!read_only">
                    <b-card id="structure-preview" class="mb-4"
                            :header="`${sub_code} / Preview`"
                    >
                        <template v-if="sub">
                            <b-tabs>
                                <b-tab title="문항 미리보기" class="p-3 border-right border-left border-bottom">
                                    <sub-component
                                        :sub_type="sub.sub_type"
                                        :item="sub"
                                        :preview="true"
                                        :view_pipe_line="false"
                                        :is_disabled_by_parent="true"
                                        :skip_info="true"
                                    />
                                </b-tab>
                                <b-tab title="문항 데이터 보기" class="p-3 border-right border-left border-bottom">
                                    <div class="mb-3">
                                        <p class="font-weight-bold mb-1">해당없음, 증빙첨부 여부, 필수답변, 첨부필수(sub_data_header)</p>
                                        <div class="border rounded vh-100" style="max-height: 150px;overflow-y: auto;">
                                            <pre class="p-3">{{ sub.sub_data_header }}</pre>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="font-weight-bold mb-1">문항 보기 및 표 구조(sub_data_contents)</p>
                                        <div class="border rounded vh-100" style="max-height: 250px;overflow-y: auto;">
                                            <pre class="p-3">{{ sub.sub_data_contents }}</pre>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </template>
                    </b-card>
                </template>

                <div class="text-right mb-2">
                    <b-button
                        class="mr-2"
                        variant="info"
                        :disabled="is_scoring_loading || is_scoring_saving"
                        @click="createScoringMethod"
                    >
                        점수조건 추가
                    </b-button>
                    <b-button
                        variant="blue"
                        class="mr-2"
                        :disabled="(!is_scoring_edited && !is_changed_scoring_structure) || is_scoring_loading || is_scoring_saving"
                        @click="handleSave"
                    >
                        저장
                        <b-spinner v-show="is_scoring_saving" style="width: 1.3rem; height: 1.3rem;"></b-spinner>
                    </b-button>
                    <b-button
                        variant="dark"
                        :disabled="is_scoring_loading || is_scoring_saving"
                        @click="$emit('click-cancel')"
                    >
                        취소
                    </b-button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {debounce} from 'lodash';
import {getErrorMessage} from '@core/utils/api/errorMessage';
import * as ih from '@core_utils/util';
import subComponent from '@core_components/client/components/subs/SubComponent.vue';
import draggable from 'vuedraggable';

export default {
    name: 'EditingScoringMethodV2',
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        },
        read_only: {
            type: Boolean,
            default: false
        },
    },
    components: {
        draggable,
        subComponent
    },
    data() {
        return {
            is_scoring_loading: false,
            is_scoring_edited: null,
            is_scoring_saving: false,
            is_scoring_translated: false,
            is_scoring_structure_edited: [],
            immutable_scoring_structure: [],
            scoring_structure: [],

            formula: '',
            name: '',
            name_ca: '',
            name_ea: '',
            reverse_name: '',
            reverse_name_ea: '',
            reverse_name_ca: '',
            score: '',
            temp_new: false,

            // sub_data_header: {},
            sub: null,
            sub_data_contents: {},
            sub_description: null,
            sub_description_e: null,
            sub_description_c: null,
            alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            risk_level_lang_kr: {
                '높음': 'high',
                '중간': 'medium',
                '낮음': 'log'
            },
            risk_level_lang_ea: {
                'high': '높음',
                'medium': '중간',
                'log': '낮음'
            },

            isDragging: false
        };
    },
    computed: {
        ...mapState(['user_id', 'is_admin', 'question_subs']),
        ...mapGetters('evaluations', ['get_neg_ev_code_options', 'get_pos_ev_code_options']),
        is_changed_scoring_structure() {
            return this.scoring_structure.length !== this.immutable_scoring_structure.length;
        }
    },
    watch: {
        question_subs: {
            handler(_updated_question_subs) {
                this.is_scoring_loading = true;
                const _subs = this.question_subs.find(item => {
                    return item.sub_code == this.sub_code;
                });
                if (_subs) {
                    this.sub = _subs;
                    this.sub_data_contents = _subs.sub_data_contents;
                    this.sub_description = _subs.sub_description;
                } else {
                    this.sub_data_contents = {},
                    this.sub_description = '';
                }
                this.is_scoring_loading = false;
            }
        },
        is_scoring_edited(_edited) {
            this.$emit('on-prevent-modify-modal', _edited);
        }
    },
    async created() {
        this.is_scoring_loading = true;
        await this.readScoringStructure();

        const _subs = this.question_subs.find(item => {
            return item.sub_code == this.sub_code;
        });
        if (_subs) {
            this.sub = _subs;
            this.sub_data_contents = _subs.sub_data_contents;
            this.sub_description = _subs.sub_description;
        } else {
            this.sub_data_contents = {},
            this.sub_description = '';
        }
        this.is_scoring_loading = false;
    },
    methods: {
        async readScoringStructure() {
            try {
                const response = await this.$axios.get(`/evaluation/${this.sub_code}`);

                this.transformEvalutaionData(response.data[this.sub_code] ?? []);
            } catch (error) {
                this.common_error_handling(error);
            } finally {
                this.is_scoring_edited = false;
                this.is_scoring_saving = false;
            }
        },
        async createScoringMethod() {
            if (this.sub_type !== 'checkbox') {
                await this.addMethod();
            } else {
                await this.addFullCheckboxMethod();
            }
        },
        changeRiskLevel(str_index, _risk_level) {
            this.scoring_structure[str_index].risk_level = this.risk_level_lang_kr[_risk_level];
            this.editedScoreMethod(str_index, 'risk_level');
        },
        async addMethod() {
            let new_scoring_method = {};

            if (this.sub_type == 'radio') {
                new_scoring_method.formula = 'result==\'예\'';
            } else if (this.sub_type == 'checkbox') {
                new_scoring_method.formula = '\'value\' in result';
            } else if (this.sub_type == 'input_number') {
                new_scoring_method.formula = 'result >= 75';
            } else if (this.sub_type == 'table') {
                // 표 기본 헤더에 실제로 있는 컬럼을 참조한다. 없는 컬럼을 참조하면
                // 검증은 통과하는데 런타임에서 조용히 0 으로 계산된다.
                new_scoring_method.formula = 'structure[0][\'구분\'] >= 0';
            } else if (this.sub_type == 'file_url2') {
                new_scoring_method.formula = 'result[0][\'filename\'] !=\'\'';
            } else {
                new_scoring_method.formula = '';
            }

            if (this.sub_type == 'radio' || this.sub_type == 'input_number') {
                new_scoring_method.name = '참고 ' + this.sub_description;
                new_scoring_method.reverse_name = this.getRevereseName(new_scoring_method.name);
            } else {
                new_scoring_method.name = '';
                new_scoring_method.reverse_name = '';
            }

            new_scoring_method.pos_ev_code = null;
            new_scoring_method.neg_ev_code = null;
            new_scoring_method.ignore_attach = null;
            new_scoring_method.is_compliance = false;
            new_scoring_method.is_ap = false;
            new_scoring_method.ap_description = null;
            new_scoring_method.ap_description_ea = null;
            new_scoring_method.ap_description_ca = null;
            new_scoring_method.risk_level = typeof new_scoring_method.risk_level === 'undefined' ? null : 'medium';
            new_scoring_method.kesg_id = null;

            this.scoring_structure.push(new_scoring_method);
        },
        async addFullCheckboxMethod() {
            if (this.sub_data_contents.structure) {
                for (let i = 0; i < this.sub_data_contents.structure.length; i++) {
                    let new_scoring_method = {};
                    let value = this.sub_data_contents.structure[i].value;

                    new_scoring_method.formula = '\'' + value + '\'' + ' in result';
                    new_scoring_method.name = value;
                    new_scoring_method.reverse_name = this.getRevereseName(new_scoring_method.name);
                    new_scoring_method.score = '+1';

                    this.scoring_structure.push(new_scoring_method);
                }
            }
        },
        async deleteMethod(j) {
            this.scoring_structure.splice(j, 1);
        },
        async handleSave() {
            const testScoreValidation = this.validateRequireScoreField();
            if (testScoreValidation) {
                await this.saveScoringMethod();
            }
        },
        validateRequireScoreField() {
            let evaluations = ih.deepCopy(this.scoring_structure);
            if (!evaluations.length) {
                return false;
            } else {
                for (const _evaluation of evaluations) {
                    const {
                        formula, name, reverse_name,
                        ap_description, is_ap
                    } = _evaluation;

                    if (this.isFieldEmpty(formula)) {
                        alert('"평가결과 산출식"을 입력해주세요.');
                        return false;
                    }

                    if (this.isFieldEmpty(name) && this.isFieldEmpty(reverse_name)) {
                        alert('"충족" / "미충족" 중에 최소 한가지는 입력해주세요.');
                        return false;
                    }

                    if (is_ap) {
                        if (this.isFieldEmpty(ap_description)) {
                            alert('"컴플라이언스" 선택시 액션플랜 적용 국문 설명 입력해주셔애 합니다.');
                            return false;
                        }
                    }
                }
            }

            return true;
        },
        async saveScoringMethod() {
            try {
                this.is_scoring_saving = true;
                let evaluations = ih.deepCopy(this.scoring_structure);

                const _saving_evaluations = evaluations.reduce((_evaluations, _evaluation, idx) => {
                    let _saving_evaluation = {
                        order: idx + 1
                    };
                    const {
                        formula, name, reverse_name, ap_description,
                        is_ap, is_compliance,
                        risk_level, kesg_id, pos_ev_code, neg_ev_code, ignore_attach
                    } = _evaluation;

                    _saving_evaluation.formula = formula;
                    // id 확인
                    if (_evaluation.id) {
                        _saving_evaluation.ev_id = _evaluation.id;
                    }
                    if (_evaluation.ev_id) {
                        _saving_evaluation.ev_id = _evaluation.ev_id;
                    }

                    // 충족
                    _saving_evaluation.name = !this.isFieldEmpty(name) ? name : null;

                    const {name_ea, name_ca} = _evaluation;
                    _saving_evaluation.name_ea = !this.isFieldEmpty(name_ea) ? name_ea : null;
                    _saving_evaluation.name_ca = !this.isFieldEmpty(name_ca) ? name_ca : null;

                    // 미충족
                    _saving_evaluation.reverse_name = !this.isFieldEmpty(reverse_name) ? reverse_name : null;

                    const {reverse_name_ea, reverse_name_ca} = _evaluation;
                    _saving_evaluation.reverse_name_ea = !this.isFieldEmpty(reverse_name_ea) ? reverse_name_ea : null;
                    _saving_evaluation.reverse_name_ca = !this.isFieldEmpty(reverse_name_ca) ? reverse_name_ca : null;

                    // 액션 플랜
                    _saving_evaluation.ap_description = null;
                    _saving_evaluation.ap_description_ea = null;
                    _saving_evaluation.ap_description_ca = null; 
                    if (is_ap) {
                        _saving_evaluation.ap_description = ap_description;

                        const {ap_description_ea, ap_description_ca} = _evaluation;
                        if (!this.isFieldEmpty(ap_description_ea)) {
                            _saving_evaluation.ap_description_ea = ap_description_ea;
                        }

                        if (!this.isFieldEmpty(ap_description_ca)) {
                            _saving_evaluation.ap_description_ca = ap_description_ca;
                        }
                    }

                    // 액션 플랜, 컴플라이언스 체크

                    _saving_evaluation.is_ap = is_ap ? '1' : '0';
                    _saving_evaluation.is_compliance = is_compliance ? '1' : '0';

                    // 리스크 레벨, kesg_id, 점수
                    _saving_evaluation.risk_lv = risk_level;
                    _saving_evaluation.kesg_id = kesg_id;
                    _saving_evaluation.pos_ev_code = pos_ev_code ?? null;
                    _saving_evaluation.neg_ev_code = neg_ev_code ?? null;
                    _saving_evaluation.ignore_attach = ignore_attach;
                    

                    _evaluations.push(_saving_evaluation);
                    return _evaluations;
                }, []);
                const _res_save_evaluations = await this.$axios.post(`/evaluation/${this.sub_code}`, {
                    evaluations: _saving_evaluations
                });
                this.transformEvalutaionData(_res_save_evaluations.data);
                // 성공했을 때만 '변경됨'을 해제한다(실패 시 모달 닫기 경고 유지)
                this.is_scoring_edited = false;
                this.$EventBus.$emit('toast-success', '성공', '점수계산 방법을 저장하였습니다.');
            } catch (error) {
                this.common_error_handling(error);
                this.$EventBus.$emit('toast-failure', '점수계산 방법 저장 실패', getErrorMessage(error, '저장하지 못했습니다. 입력한 내용은 그대로 두었으니 다시 시도해주세요.'));
            } finally {
                this.is_scoring_saving = false;
            }
        },
        transformEvalutaionData(_evalutaions) {
            if (_evalutaions.length === 0) {
                this.temp_new = true;
                this.$emit('score_not_defined', true);
            } else {
                this.is_scoring_structure_edited = [];
                for (let i = 0; i < _evalutaions.length; i++) {
                    // 이하의 field는 Optional
                    if (!_evalutaions[i].risk_lv) {
                        _evalutaions[i].risk_level = null;
                    } else {
                        _evalutaions[i].risk_level = _evalutaions[i].risk_lv;
                    }

                    _evalutaions[i].is_compliance = typeof _evalutaions[i].is_compliance !== 'boolean' ? Boolean(Number(_evalutaions[i].is_compliance)) : (_evalutaions[i].is_compliance || false);
                    _evalutaions[i].is_ap = typeof _evalutaions[i].is_ap !== 'boolean' ? Boolean(Number(_evalutaions[i].is_ap)) : (_evalutaions[i].is_ap || false);

                    if (!_evalutaions[i].is_ap) {
                        _evalutaions[i].ap_description = null;
                        _evalutaions[i].ap_description_ea = null;
                        _evalutaions[i].ap_description_ca = null;
                    }

                    _evalutaions[i].kesg_id = !_evalutaions[i].kesg_id ? null : _evalutaions[i].kesg_id;

                    _evalutaions.is_translating_name_ea = false;
                    _evalutaions.is_translating_name_ca = false;
                    _evalutaions.is_translating_reverse_name_ea = false;
                    _evalutaions.is_translating_reverse_name_ca = false;
                    _evalutaions.is_translating_ap_description_ea = false;
                    _evalutaions.is_translating_ap_description_ca = false;
                }

                this.is_scoring_structure_edited.push(false);
            }

            this.scoring_structure = _evalutaions.map(item => {
                return {
                    ...item,
                    is_compliance: item.is_compliance || false,
                    is_ap:  item.is_ap || false
                };
            });
            this.immutable_scoring_structure = JSON.parse(JSON.stringify(_evalutaions));
        },
        getRevereseName(text) {
            // console.log(text);
            //0. trim 처리
            let target_text = text.replace('.', '').trim();
            //1. 있음 <-> 없음 처리
            if (target_text.match(/있음$/gi) !== null) {
                target_text = target_text.replace(/있음$/gi, '없음');
            } else if (target_text.match(/없음$/gi) !== null) {
                target_text = target_text.replace(/없음$/gi, '있음');
            }

            //2. 함 <-> 하지 않음 처리
            if (target_text.match(/함$/gi) !== null) {
                target_text = target_text.replace(/함$/gi, '하지 않음');
            } else if (target_text.match(/하지 않음$/gi) !== null) {
                target_text = target_text.replace(/하지 않음$/gi, '함');

            } else if (target_text.match(/하지않음$/gi) !== null) {
                target_text = target_text.replace(/하지않음/gi, '함');
            }

            //3. 받음 <-> 받지 않음 처리
            if (target_text.match(/받음$/gi) !== null) {
                target_text = target_text.replace(/받음$/gi, '받지 않음');
            } else if (target_text.match(/받지 않음$/gi) !== null) {
                target_text = target_text.replace(/받지 않음$/gi, '받음');
            } else if (target_text.match(/받지않음$/gi) !== null) {
                target_text = target_text.replace(/받지않음/gi, '받음');
            }

            //4. 이상<->미만, 이하<->초과
            if (target_text.match(/이상/gi) !== null) {
                target_text = target_text.replace(/이상/gi, '미만');
            } else if (target_text.match(/미만/gi) !== null) {
                target_text = target_text.replace(/미만/gi, '이상');
            } else if (target_text.match(/이하/gi) !== null) {
                target_text = target_text.replace(/이하/gi, '초과');
            } else if (target_text.match(/초과/gi) !== null) {
                target_text = target_text.replace(/초과/gi, '이하');
            }

            return target_text;
        },
        editedScoreMethod: debounce(function (str_index, field) {
            if (!this.is_changed_scoring_structure) {
                let is_scoring_structure_edited = false;

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].formula !== this.immutable_scoring_structure[str_index].formula;
                }

                if (field === 'name') {
                    // 직접 쓴 미충족 문구는 덮어쓰지 않는다. 비었거나 자동 생성된 값(저장본 또는 직전 자동값)일 때만 현재 충족 문구 기준으로 다시 만든다.
                    const _row = this.scoring_structure[str_index];
                    this.auto_reverse_names = this.auto_reverse_names || {};
                    const _auto_candidates = [this.getRevereseName(this.immutable_scoring_structure[str_index].name), this.auto_reverse_names[str_index]];
                    if (this.isFieldEmpty(_row.reverse_name) || _auto_candidates.includes(_row.reverse_name)) {
                        _row.reverse_name = this.getRevereseName(_row.name);
                        this.auto_reverse_names[str_index] = _row.reverse_name;
                    }
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].name !== this.immutable_scoring_structure[str_index].name;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].name_ea !== this.immutable_scoring_structure[str_index].name_ea;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].name_ca !== this.immutable_scoring_structure[str_index].name_ca;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].reverse_name !== this.immutable_scoring_structure[str_index].reverse_name;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].reverse_name_ea !== this.immutable_scoring_structure[str_index].reverse_name_ea;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].reverse_name_ca !== this.immutable_scoring_structure[str_index].reverse_name_ca;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].is_ap !== this.immutable_scoring_structure[str_index].is_ap;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].is_compliance !== this.immutable_scoring_structure[str_index].is_compliance;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].ap_description !== this.immutable_scoring_structure[str_index].ap_description;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].ap_description_ea !== this.immutable_scoring_structure[str_index].ap_description_ea;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].ap_description_ca !== this.immutable_scoring_structure[str_index].ap_description_ca;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].risk_level !== this.immutable_scoring_structure[str_index].risk_level;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].kesg_id !== this.immutable_scoring_structure[str_index].kesg_id;
                }


                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].pos_ev_code !== this.immutable_scoring_structure[str_index].pos_ev_code;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].neg_ev_code !== this.immutable_scoring_structure[str_index].neg_ev_code;
                }

                if (!is_scoring_structure_edited) {
                    is_scoring_structure_edited = this.scoring_structure[str_index].ignore_attach !== this.immutable_scoring_structure[str_index].ignore_attach;
                }

                console.log(` ~ is_scoring_structure_edited => ${is_scoring_structure_edited}`);

                this.is_scoring_structure_edited[str_index] = is_scoring_structure_edited;
                this.is_scoring_edited = this.is_scoring_structure_edited.some(_scoring_structure => _scoring_structure === true);
            } else {
                this.is_scoring_edited = this.is_changed_scoring_structure;
            }
        }, 350),
        async translateScoringTextField(scoring_idx, translatingField, inputField, translatingLang) {
            try {
                this.is_scoring_translated = true;
                this.scoring_structure[scoring_idx][`is_translating_${inputField}`] = true;


                if (!this.isFieldEmpty(this.scoring_structure[scoring_idx][inputField])) {
                    const _confirmed_overwrite = confirm('기본에 입력된 번역 데이터가 있습니다. 덮어 쓰시겠습니까?');
                    if (_confirmed_overwrite) {
                        const _translated_field = await this.$axios.get('/translate', {
                            params: {
                                text: this.scoring_structure[scoring_idx][translatingField],
                                target_lang: translatingLang
                            }
                        });
                        this.scoring_structure[scoring_idx][inputField] = _translated_field.data;
                    }
                } else {
                    const _translated_field = await this.$axios.get('/translate', {
                        params: {
                            text: this.scoring_structure[scoring_idx][translatingField],
                            target_lang: translatingLang
                        }
                    });
                    this.scoring_structure[scoring_idx][inputField] = _translated_field.data;
                }

                this.editedScoreMethod(scoring_idx);
            } catch (error) {
                this.common_error_handling(error);
            } finally {
                this.scoring_structure[scoring_idx][`is_translating_${inputField}`] = false;
                this.is_scoring_translated = false;
            }
        },
        onDragEnd() {
            this.isDragging = false;
            // 순서만 변경되어 길이는 동일하므로 직접 수정 플래그를 켬
            this.is_scoring_edited = true;
        }
    }
};
</script>

<style lang="scss">
/* #structure-preview > .card-header {
    padding: 0.25rem 1.25rem;
} */
#structure-preview > .card-body > .table td {
    text-align: left;
}

// Common draggable UI

// Container utility used on draggable root
.draggable-list {
    .ghost-placeholder {
        opacity: 0.5;
        background: #e6f7ff;
        border: 2px dashed #007bff;
        border-radius: 8px;
        & > * {
            visibility: hidden;
        }
    }
}

// Applied on the element being dragged (or wrapper)
.dragging-item {
    opacity: 0.8;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: #fff;
}

// Drag handle icon/button
.drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    color: #6c757d;
    cursor: grab;
    &:active {
        cursor: grabbing;
    }
}
</style>
